/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Origin_HeadingInputs */

const en_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const id_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ms_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ca_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const cs_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const da_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const de_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const et_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const es_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const fr_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hr_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const it_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const lv_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const lt_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hu_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const nl_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const nb_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const pl_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const pt_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ro_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sk_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sl_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const fi_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sv_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const vi_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const tr_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const el_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const bg_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ru_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const sr_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const uk_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ka_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const hi_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const th_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ko_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const zh_tw_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

const ja_brave_origin_heading = /** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Origin`)
};

/** @type {(inputs: Brave_Origin_HeadingInputs) => LocalizedString} */
const zh_brave_origin_heading = en_brave_origin_heading;

/**
* | output |
* | --- |
* | "Brave Origin" |
*
* @param {Brave_Origin_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_origin_heading = /** @type {((inputs?: Brave_Origin_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Origin_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_origin_heading(inputs)
	if (locale === "ms") return ms_brave_origin_heading(inputs)
	if (locale === "ca") return ca_brave_origin_heading(inputs)
	if (locale === "cs") return cs_brave_origin_heading(inputs)
	if (locale === "da") return da_brave_origin_heading(inputs)
	if (locale === "de") return de_brave_origin_heading(inputs)
	if (locale === "et") return et_brave_origin_heading(inputs)
	if (locale === "es") return es_brave_origin_heading(inputs)
	if (locale === "fr") return fr_brave_origin_heading(inputs)
	if (locale === "hr") return hr_brave_origin_heading(inputs)
	if (locale === "it") return it_brave_origin_heading(inputs)
	if (locale === "lv") return lv_brave_origin_heading(inputs)
	if (locale === "lt") return lt_brave_origin_heading(inputs)
	if (locale === "hu") return hu_brave_origin_heading(inputs)
	if (locale === "nl") return nl_brave_origin_heading(inputs)
	if (locale === "nb") return nb_brave_origin_heading(inputs)
	if (locale === "pl") return pl_brave_origin_heading(inputs)
	if (locale === "pt") return pt_brave_origin_heading(inputs)
	if (locale === "ro") return ro_brave_origin_heading(inputs)
	if (locale === "sk") return sk_brave_origin_heading(inputs)
	if (locale === "sl") return sl_brave_origin_heading(inputs)
	if (locale === "fi") return fi_brave_origin_heading(inputs)
	if (locale === "sv") return sv_brave_origin_heading(inputs)
	if (locale === "vi") return vi_brave_origin_heading(inputs)
	if (locale === "tr") return tr_brave_origin_heading(inputs)
	if (locale === "el") return el_brave_origin_heading(inputs)
	if (locale === "bg") return bg_brave_origin_heading(inputs)
	if (locale === "ru") return ru_brave_origin_heading(inputs)
	if (locale === "sr") return sr_brave_origin_heading(inputs)
	if (locale === "uk") return uk_brave_origin_heading(inputs)
	if (locale === "ka") return ka_brave_origin_heading(inputs)
	if (locale === "hi") return hi_brave_origin_heading(inputs)
	if (locale === "th") return th_brave_origin_heading(inputs)
	if (locale === "ko") return ko_brave_origin_heading(inputs)
	if (locale === "zh") return zh_brave_origin_heading(inputs)
	if (locale === "zh-tw") return zh_tw_brave_origin_heading(inputs)
	if (locale === "ja") return ja_brave_origin_heading(inputs)
	return en_brave_origin_heading(inputs)
});